/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
import { getDispatchTypeDetailName } from "../../../../../../../../../../utils/getDispatchTypeDetailName"
import { getFullName } from "../../../../../../../../../../utils/getFullName"
import {
  SchedulesExportFRM103ResType,
  SchedulesExportFRM103Type,
} from "../../../../../../../models/list/export"
import {
  buildJoinedBySlash,
  getDate,
  getTime,
  groupByTravelerId,
} from "../../utils"
import { Variables } from "../../../../../../../../travelers/constants/edit/variables"
import { getValueByLanguage } from "../../../../../../../../../../utils/getValueByLanguage"
import { joinItemByTilde } from "../../../../../utils/joinItemByTilde"
import { getDisplayDateTime } from "../../../../../utils/getDisplayDateTime"

const { KEYS_ACCOMPANYING_FAMILY } = Variables

export const convertDataExportExcel = (
  dataSource: SchedulesExportFRM103ResType[],
): SchedulesExportFRM103Type[] =>
  groupByTravelerId(dataSource).map(({ details, info, lodgings, stays }) => ({
    departureDateTimeAndArrivalDateTime: joinItemByTilde(
      getDisplayDateTime(info.dispatchStartDate),
      getDisplayDateTime(info.dispatchEndDate),
    ),
    dispatchTypeDetailName: getDispatchTypeDetailName(
      info.bumonName,
      info.dispatchTypeDetailId,
      info.dispatchTypeDetailName,
      true,
    ),
    fullNameKanji: getFullName(info.kanjiSurname, info.kanjiName, true),
    fullNameRomaji: getFullName(info.romajiSurname, info.romajiName),
    groupName: KEYS_ACCOMPANYING_FAMILY.includes(info.dispatchTypeDetailId)
      ? info.personDispatcherName
      : info.organizationName.split("・")[0],
    locationPersonName: info.locationPersonName,
    othersRemarks1: info.othersRemarks1,
    personEmailAddress: info.emailAddress1,
    phoneNumber: info.locationPhoneNumber1,
    projectNameJpOrProjectNameEn: getValueByLanguage(
      info.projectNameJp,
      info.projectNameEn,
    ).toString(),
    travelerLocation: info.travelerLocation || "",
    travelPurposeName: info.travelPurposeName,
    workPlaceCountryAndWorkPlaceCity: `${info.workPlaceCountry} ${info.workPlaceCity}`,

    ...buildJoinedBySlash({
      data: details,
      fields: [
        { key: "departureDateTime", fn: getDate, alias: "departureDate" },
        { key: "departureDateTime", fn: getTime, alias: "departureTime" },
        { key: "departureCountryName" },
        { key: "departureCityName" },
        { key: "arrivalDateTime", fn: getDate, alias: "arrivalDate" },
        { key: "arrivalDateTime", fn: getTime, alias: "arrivalTime" },
        { key: "arrivalCountryName" },
        { key: "arrivalCityName" },
      ],
    }),

    ...buildJoinedBySlash({
      data: lodgings,
      fields: [
        { key: "lodgingCheckin", fn: getDate },
        { key: "lodgingCheckout", fn: getDate },
        { key: "lodgingName" },
        { key: "lodgingAddress" },
        { key: "lodgingPhoneNumber" },
      ],
    }),

    ...buildJoinedBySlash({
      data: stays,
      fields: [
        { key: "locationPhoneNumber1" },
        { key: "locationPhoneNumber2" },
        { key: "satellitePhoneNumber" },
        { key: "emailAddress1" },
        { key: "emailAddress2" },
      ],
    }),
  })) as SchedulesExportFRM103Type[]
